import { render, staticRenderFns } from "./pop-up-infomation.vue?vue&type=template&id=5de34079&scoped=true"
import script from "./pop-up-infomation.vue?vue&type=script&lang=js"
export * from "./pop-up-infomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de34079",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5de34079')) {
      api.createRecord('5de34079', component.options)
    } else {
      api.reload('5de34079', component.options)
    }
    module.hot.accept("./pop-up-infomation.vue?vue&type=template&id=5de34079&scoped=true", function () {
      api.rerender('5de34079', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Campaign/TabPrize/components/Infomation/pop-up-infomation.vue"
export default component.exports